import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IFormulareResponseRow } from 'fa-kt.types';
import { BehaviorSubject } from 'rxjs';
import { FormulareService } from '../service';

@Component({
  selector: 'fa-kt-formulare-list',
  templateUrl: './formulare-list.component.html',
  styleUrls: ['./formulare-list.component.css'],
})
export class FormulareListComponent {
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() set loading(loading: boolean) {
    this.$loading.next(this.$loading.getValue() || loading);
  }
  @Input() height = 'calc(100vh - 324px)';

  @Output() select: EventEmitter<string> = new EventEmitter<string>();

  constructor(public formulare: FormulareService) {}

  public set(formulare: IFormulareResponseRow) {
    /* << custom    */
    this.select.emit(formulare.formular.id);
    /*    custom >> */
  }
}
